export function hasTimeSlotShippingMethods(checkout) {
  return checkout.shippingInfo?.carrierServiceOptions?.some(_ref => {
    let {
      shippingOptions
    } = _ref;
    return shippingOptions?.some(_ref2 => {
      let {
        logistics
      } = _ref2;
      return !!logistics?.deliveryTimeSlot?.from;
    }) ?? false;
  }) ?? false;
}
//# sourceMappingURL=hasTimeSlotShippingMethods.js.map